import { render, staticRenderFns } from "./VaccineComponent.vue?vue&type=template&id=187d95e6&"
import script from "./VaccineComponent.vue?vue&type=script&lang=js&"
export * from "./VaccineComponent.vue?vue&type=script&lang=js&"
import style0 from "./VaccineComponent.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports